import type { UiRoot } from "../ui/UiRoot";
import type { Scene } from "./Scene";

export class PauseScene implements Scene {
  readonly id = "pause" as const;
  constructor(private readonly ui: UiRoot) {}
  enter(): void {
    this.ui.show("pause");
  }
  exit(): void {}
}
